import PropTypes from "prop-types"
import tinycolor from "tinycolor2"
import React, {Component} from "react"
import {connect} from "react-redux"

import {uploadImage} from "@irati/images/services/image"
import authentication from "@irati/auth"
import AuthActions from "@irati/auth/store/actions/AuthActions"
import adminTracking from "@irati-tracking/admin"
import id from "@irati/utils/id"
import brandingService from "@irati/brand/services/branding"
import Loading from "@irati/ui/src/Loading"
import mainTheme from "@irati/ui/src/global/theme"

import UploadLogoStep from "./UploadLogoStep"
import ScaleLogoStep from "./ScaleLogoStep"
import PickColorStep from "./PickColorStep"
import BrandSettings from "./BrandSettings"

const SELECT_LOGO_OR_COLOR = "select_logo_or_color"
const UPLOAD_LOGO = "upload_logo"
const SCALE_LOGO = "scale_logo"
const PICK_COLOR = "pick_color"

class UpdateBrand extends Component {
  static propTypes = {
    onBrandUpdated: PropTypes.func.isRequired,
    updateAuthTenant: PropTypes.func.isRequired,
    imageLink: PropTypes.string.isRequired,
    showUpload: PropTypes.bool.isRequired,
    onColorUpdate: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.state = {
      logoFile: null,
      logoContents: null,
      currentStep: props.showUpload ? UPLOAD_LOGO : SELECT_LOGO_OR_COLOR,
      colorsList: false,
      showSkip: true
    }
  }

  componentDidMount() {
    if (this.props.imageLink) {
      const that = this
      const img = document.createElement("img")
      img.crossOrigin = "Anonymous"
      img.onload = function() {
        const colorThief = new window.ColorThief()
        that.setState({
          colorsList: colorThief.getPalette(img, 2)
        })
      }
      img.src = this.props.imageLink
    }
  }

  onLogoUploaded = (file, contents) => {
    this.setState({
      logoFile: file,
      logoContents: contents,
      currentStep: SCALE_LOGO
    })
    adminTracking.updateLogo()
  }

  onLogoScaled = (resizedImage) => {
    const colorThief = new window.ColorThief()
    const colorsList = colorThief.getPalette(resizedImage, 2)
    const base64Image = resizedImage.toDataURL()

    const saving = uploadImage(base64Image).then((imageLink) => {
      const tenant = authentication.userTenant()

      return brandingService.update({businessId: tenant.uuid, teamId: tenant.rootTeamId, businessLogoUrl: imageLink}).then(() => {
        this.setState({
          colorsList,
          currentStep: PICK_COLOR,
          showSkip: true
        })
        return this.props.updateAuthTenant()
      })
    })

    this.setState({saving})
  }

  onColorSelected = (color) => {
    const tenant = authentication.userTenant()

    const data = {
      businessId: tenant.uuid,
      teamId: tenant.rootTeamId,
      primaryColour: color,
      textColour: tinycolor(color).isLight() ? mainTheme.colors.utility.ink : mainTheme.colors.utility.white
    }

    const saving = brandingService.update(data).then(() => {
      this.props.onBrandUpdated()
      if (this.props.onColorUpdate) {
        this.props.onColorUpdate(color)
      }
      return this.props.updateAuthTenant()
    })

    this.setState({saving})
  }

  updateCurrentStepToUploadLogo = () => {
    this.setState({
      currentStep: UPLOAD_LOGO,
      logoFile: null,
      logoContents: null
    })
  }

  handleBrandSettingsClickColor = () => {
    this.setState({
      currentStep: PICK_COLOR,
      showSkip: false
    })
  }

  getStep = () => {
    const {currentStep, colorsList, logoContents, showSkip} = this.state

    switch (currentStep) {
      case SELECT_LOGO_OR_COLOR:
        return (
          <BrandSettings
            handleBrandSettingsClickLogo={this.updateCurrentStepToUploadLogo}
            handleBrandSettingsClickColor={this.handleBrandSettingsClickColor} />
        )
      case UPLOAD_LOGO:
        return <UploadLogoStep onComplete={this.onLogoUploaded} />
      case SCALE_LOGO:
        return (
          <ScaleLogoStep imageSource={logoContents} backToUploadLogo={this.updateCurrentStepToUploadLogo} onComplete={this.onLogoScaled} />
        )
      case PICK_COLOR:
        return (
          <PickColorStep
            id={id("pick-colors", this.props)}
            colorsList={colorsList}
            onColorSelected={this.onColorSelected}
            onSkip={this.props.onBrandUpdated}
            showSkip={showSkip} />
        )
      default:
        return <div>UNKNOWN STEP</div>
    }
  }

  render() {
    const {saving} = this.state
    const idNamespace = id("update-brand-modal", this.props)

    return (
      <Loading id={idNamespace} load={saving}>
        {this.getStep()}
      </Loading>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateAuthTenant: () => dispatch(AuthActions.updateTenant())
  }
}

export default connect(
  null,
  mapDispatchToProps
)(UpdateBrand)
